import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { AdapterService } from './core/services/adapter.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'ClientApp';

  constructor(private readonly adapterService: AdapterService,
    private readonly ngZone: NgZone) { }

  ngOnInit(): void {
    this.listenForIframeAuth();
  }

  ngOnDestroy(): void {
    if (this.messageHandler) {
      window.removeEventListener('message', this.messageHandler);
      this.messageHandler = null;
    }
  }

  private messageHandler: ((event: MessageEvent) => void) | null = null;

  private listenForIframeAuth(): void {
    if (typeof window === 'undefined') {
      console.log('[app.component] Skipping iframe auth listener (non-browser environment).');
      return;
    }

    const allowedOrigins = environment.iframeAuth?.allowedOrigins || [];
    console.log('[app.component] iframeAuth allowed origins:', allowedOrigins);

    this.messageHandler = (event: MessageEvent) => {
      // event.origin is the origin of the PARENT page that embedded this app
      // in an iframe. It does NOT have to match this app's own origin.
      console.log('[app.component] Received message from origin:', event.origin);
      console.log('[app.component] Received message data:', event.data);

      const originAllowed = allowedOrigins.includes(event.origin);
      console.log('[app.component] Origin allowed?', originAllowed);
      if (!originAllowed) {
        return;
      }

      const data = event.data;
      if (!data || data.type !== 'fotiou.auth' || !data.userInfo) {
        console.warn('[app.component] Message ignored: unexpected type or missing userInfo.');
        return;
      }

      const userInfo = data.userInfo;
      const hasAccessToken = !!userInfo.accessToken;
      const hasRoleId = !!userInfo.roleId;
      console.log('[app.component] userInfo.hasAccessToken:', hasAccessToken, '| hasRoleId:', hasRoleId);

      if (!hasAccessToken || !hasRoleId) {
        console.warn('[app.component] Message ignored: missing accessToken or roleId.');
        return;
      }

      // Persist the user object in this iframe's own localStorage.
      // localStorage is scoped to the iframe's origin and is NOT shared
      // with the parent, which is why postMessage is used.
      this.ngZone.run(() => {
        console.log('[app.component] Persisting userInfo to localStorage via AdapterService.');
        this.adapterService.setLocalStorageValue(environment.storageKeys.userInfo, userInfo);
      });

      // Stop listening once we have a valid auth message.
      console.log('[app.component] Auth accepted; removing message listener.');
      window.removeEventListener('message', this.messageHandler!);
      this.messageHandler = null;
    };

    console.log('[app.component] Attached iframe auth message listener.');
    window.addEventListener('message', this.messageHandler);
  }
}
